import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { signInWithCustomToken } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../../firebase/config";
import { useAuth } from "../contexts/AuthContext";

function errorMessage(error: unknown) {
  if (error && typeof error === "object" && "message" in error) {
    const message = String((error as { message?: string }).message || "");
    if (message) return message;
  }
  return "Invalid authentication code";
}

const AuthenticatorGate: React.FC = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();
  const toast = useToast();

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    try {
      const confirm = httpsCallable<{ token: string }, { customToken?: string }>(
        functions,
        "confirmAdminAuthenticator"
      );
      const result = await confirm({ token: code });
      if (!result.data.customToken) throw new Error("Sign-in did not complete");
      await signInWithCustomToken(auth, result.data.customToken);
    } catch (error) {
      toast({
        title: "Login Failed",
        description: errorMessage(error),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="#f4fafc" px={4}>
      <VStack
        as="form"
        onSubmit={submit}
        spacing={4}
        p={8}
        bg="white"
        borderRadius="lg"
        border="1px solid"
        borderColor="#d5e4ea"
        boxShadow="sm"
        w="100%"
        maxW="420px"
      >
        <Box as="img" src="/red_eagle/red_eagle_48.png" alt="" w="48px" h="48px" />
        <Text fontSize="xl" fontWeight="600" color="#023047">
          Authenticator
        </Text>
        <Text fontSize="sm" color="gray.600">
          Enter the 6-digit code from your authenticator app.
        </Text>
        <FormControl>
          <FormLabel>Authentication code</FormLabel>
          <Input
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/\D/g, "").slice(0, 6))}
            inputMode="numeric"
            autoComplete="one-time-code"
          />
        </FormControl>
        <Button type="submit" width="100%" isLoading={loading} isDisabled={code.length !== 6}>
          Verify
        </Button>
        <Button type="button" variant="ghost" width="100%" onClick={() => logout()}>
          Sign out
        </Button>
      </VStack>
    </Box>
  );
};

export default AuthenticatorGate;
